export default {
  name: "Participnat's name",
  role: "Participant's role",
};
